export default "__VITE_ASSET__DjZJa3yA__"